var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_112-photo-camera-1",
    transform: "translate(8.647 10.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    className: "st0",
    d: "M474,109.6H372.9L351,52.7c-2.5-6.6-8.8-11-15.9-11.1H159.5c-7.1,0-13.5,4.4-16,11.1 l-21.7,56.9H20.7c-15.6,0-28.3,12.7-28.3,28.3v283.3c0,15.6,12.7,28.3,28.3,28.3H474c15.7,0,28.3-12.7,28.3-28.3l0,0V137.9 C502.4,122.3,489.7,109.6,474,109.6C474,109.6,474,109.6,474,109.6z M468.3,415.6h-442v-272h107.1c7.1,0,13.4-4.4,15.9-11.1 l21.9-56.9h152.3l21.9,57.1c2.5,6.6,8.8,11,15.9,11.1h107.1v272L468.3,415.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    transform: "translate(3.674 2.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    className: "st0",
    d: "M243.6,143.6c-66,0-119.6,53.5-119.6,119.5s53.5,119.6,119.5,119.6 c66,0,119.6-53.5,119.6-119.5c0,0,0,0,0,0C363.1,197.2,309.6,143.7,243.6,143.6z M243.6,348.7c-47.2,0-85.6-38.3-85.6-85.6 s38.3-85.6,85.6-85.6s85.6,38.3,85.6,85.6l0,0C329.1,310.4,290.9,348.7,243.6,348.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.5b69b250f2e7d8cb735e6e7f918c88b7.svg";
export { ForwardRef as ReactComponent };